// extracted by mini-css-extract-plugin
export default {"maindiv":"ActivityReport_maindiv__nEVfn","togglediv":"ActivityReport_togglediv__MPTgk","toggleBtn":"ActivityReport_toggleBtn__L5gto","activeBtn":"ActivityReport_activeBtn__aepK9"};